import type { BannerModel, ObterBannersResposta } from "../../../services/bannerFornecedor"

export enum CadastroBannerFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    SET_URL_BANNER = "SET_URL_BANNER",
    SET_EXIBIR_CARDAPIO = "SET_EXIBIR_CARDAPIO",
    SET_EXIBIR_TELA_INICIAL = "SET_EXIBIR_TELA_INICIAL",
    ADICIONAR_BANNER = "ADICIONAR_BANNER",
    REMOVER_BANNER = "REMOVER_BANNER",
    RESETAR_FORM = "RESETAR_FORM",
}

export type CadastroBannerFornecedorActions =
    | { type: CadastroBannerFornecedorActionsTypes.CARREGAR; payload: ObterBannersResposta }
    | { type: CadastroBannerFornecedorActionsTypes.SET_URL_BANNER; payload: string | null }
    | { type: CadastroBannerFornecedorActionsTypes.SET_EXIBIR_CARDAPIO; payload: boolean }
    | { type: CadastroBannerFornecedorActionsTypes.SET_EXIBIR_TELA_INICIAL; payload: boolean }
    | { type: CadastroBannerFornecedorActionsTypes.ADICIONAR_BANNER; payload: BannerModel }
    | { type: CadastroBannerFornecedorActionsTypes.REMOVER_BANNER; payload: number }
    | { type: CadastroBannerFornecedorActionsTypes.RESETAR_FORM }
